export default function sharing() {
    $('.social-link--bf').on('click', function (e) {
        e.preventDefault();

        const $alert = $(this).parents('div').find('.alert--success'),
            $alertClose = $(this).parents('div').find('.alert__close'),
            $alertCounter = $(this).parents('div').find('.alert__count span');

        navigator.clipboard.writeText(window.location.href).then(() => {
            $alert.addClass("_active");

            $alertClose.on("click", function () {
                $alert.removeClass("_active");
            });
        }).catch(err => {
            console.error('Error: ', err);
        });

        let counter = 9,
            interval = setInterval(function() {
            counter--;

            $alertCounter.text(counter);

            if (counter == 0) {
                $alert.removeClass('_active');

                clearInterval(interval);
            }
        }, 1000);
    });

    // $('.social-link--fb').on('click', function (e) {
    //     let url = window.location.href;
    //     e.preventDefault();
    //     FB.ui({
    //         method: 'share_open_graph',
    //         action_type: 'og.likes',
    //         action_properties: JSON.stringify({
    //             object: url,
    //         })
    //     }, function(response){
    //         // Debug response (optional)
    //         console.log(response);
    //     });
    // });

    $('.alert__close').on('click', function () {
        $(this).parents('.alert').removeClass('_active');
    });
}